import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Box,
} from '@material-ui/core';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DropdownMenu from 'src/components/DropdownMenu';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative'
  },
  activeLabel: {
    color: '#009BDA',
  },
}));

function MultiSelect({ 
  label, 
  options, 
  value, 
  onChange, 
  multi = false,
}) {
  const classes = useStyles();
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const handleOptionToggle = event => {
    let newValue = [...value];

    if (event.target.checked) {
      if (!multi) {
        newValue = newValue.filter(item => !options.includes(item));
      }
      newValue.push(event.target.value);
    } else {
      newValue = newValue.filter(item => item !== event.target.value);
    }

    if (onChange) {
      onChange(newValue);
    }
  };

  const active = value.some((v) => options.includes(v));
  return (
    <Box className={classes.root}>
      <Button 
        className={clsx(active && classes.activeLabel)} 
        onClick={handleMenuOpen} 
      >
        {label}
        <ArrowDropDownIcon />
      </Button>
      <DropdownMenu 
        multi={multi}
        open={openMenu}
        onClose={handleMenuClose}
        onChange={handleOptionToggle}
        options={options}
        activeOptions={value}
      />
    </Box>
  );
}

MultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  multi: PropTypes.bool
};

export default MultiSelect;
